import { useMemo } from 'react';
import { colors, fontFamily } from '@podiumhq/podium-ui';
import { useTracking } from '@podiumhq/tracking';

const useStripeInputProps = (loading, trackOnBlurPath) => {
  const { trackEvent } = useTracking();

  const handleStripeInputBlur = (fieldName) => () =>
    trackOnBlurPath && trackEvent(`${trackOnBlurPath}.${fieldName}FieldFilled`);

  const securityCodeToolTipOptions = {
    id: 'cvc',
    tipText:
      'The 3- or 4-digit security code usually found on the back of the card.',
  };

  const stripeInputDefaultProps = useMemo(
    () => ({
      className: '.fs-mask',
      options: {
        disabled: loading,
        style: {
          base: {
            fontFamily: fontFamily,
            fontSize: '16px',
            letterSpacing: '0.05em',
            fontWeight: 400,
            color: colors.mineShaft,

            '::placeholder': {
              color: colors.lightSteel,
            },
          },
          invalid: {
            color: colors.mineShaft,
          },
        },
      },
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [loading]
  );

  const cardNumberOptions = {
    ...stripeInputDefaultProps.options,
    showIcon: true,
  };
  const cardNumberProps = {
    options: cardNumberOptions,
  };

  return {
    cardNumberProps,
    handleStripeInputBlur,
    securityCodeToolTipOptions,
    stripeInputDefaultProps,
  };
};

export default useStripeInputProps;
